import { Button, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useOpenSubscribe } from './subscribeOfferContext';

interface SubscribeCardProps {
  /** The sidebar variant: smaller padding, `body2` copy. */
  compact?: boolean;
  /** Called on the CTA before the dialog opens: the temporary drawer, or a host modal, closes first. */
  onNavigate?: () => void;
  /**
   * Ids the title so a modal showing the card in place (`SubscribeInPlace`) is named by it and can
   * move focus to it; the title then takes focus by script only (`tabIndex={-1}`).
   */
  titleId?: string;
}

/**
 * The upsell a GUEST / NONE tier sees where a subscriber-only surface would be (design §5.4,
 * §14.3) — never a disabled control. `compact` is the sidebar variant.
 */
export function SubscribeCard({ compact = false, onNavigate, titleId }: SubscribeCardProps) {
  const { t } = useTranslation();
  const openSubscribe = useOpenSubscribe();
  return (
    <Paper
      elevation={1}
      sx={{ p: compact ? 1.5 : { xs: 2, md: 3 }, maxWidth: compact ? 'none' : 480 }}
    >
      <Typography
        variant={compact ? 'subtitle1' : 'h3'}
        component="h2"
        gutterBottom
        {...(titleId !== undefined ? { id: titleId, tabIndex: -1 } : {})}
      >
        {t('subscribe.cardTitle')}
      </Typography>
      <Typography variant={compact ? 'body2' : 'body1'} sx={{ mb: 2 }}>
        {t('subscribe.cardBody')}
      </Typography>
      <Button
        variant="contained"
        size={compact ? 'small' : 'medium'}
        onClick={() => {
          onNavigate?.();
          openSubscribe();
        }}
      >
        {t('subscribe.cta')}
      </Button>
    </Paper>
  );
}
